module.exports = __webpack_public_path__ + "img/media-simplified.1367422f.jpg";